import { render } from "./agent.leads.vue?vue&type=template&id=6c113420"
import script from "./agent.leads.vue?vue&type=script&lang=js"
export * from "./agent.leads.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__